import mainNavItems from "./mainNavItems";

const mainSidebarItems = [{ href: "/", title: "Home" }, ...mainNavItems];

export default mainSidebarItems;
